import { createSelector } from 'redux-views';

export const getAuth = state => state.firebase.auth;

export const getAccessToken = createSelector([getAuth], auth => {
  const accessToken = auth?.stsTokenManager?.accessToken;

  return accessToken;
});
